const getDecodeDescription = (description) => {
  try {
    return decodeURIComponent(description);
  } catch (ex) {
    return description;
  }
};

export default getDecodeDescription;
